"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                NavBar_Actions: "Actions",
                NavBar_Pages: "Pages",
                NavBar_Search: "Search",
            }
        });
        var CombinedSearch = /** @class */ (function (_super) {
            __extends(CombinedSearch, _super);
            function CombinedSearch() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CombinedSearch.prototype.FocusIn = function () {
                var _this = this;
                this.HasFocus(true);
                if (!this.SelectorObserver) {
                    var searchSelectorContext = this.SearchSelector();
                    if (searchSelectorContext) {
                        this.SelectorObserver = $dyn.observe(searchSelectorContext.isExpanded, function (newValue) {
                            if (newValue) {
                                _this.HasFocus(true);
                            }
                        });
                    }
                }
            };
            CombinedSearch.prototype.FocusOut = function () {
                this.HasFocus(false);
            };
            CombinedSearch.prototype.SearchSelector = function () {
                if (!this._searchSelector) {
                    var selectorElement = $(this.element).find(".combinedSearch-selector")[0];
                    if (selectorElement) {
                        this._searchSelector = $dyn.context(selectorElement);
                    }
                }
                return this._searchSelector;
            };
            return CombinedSearch;
        }($dyn.ui.Control));
        controls.CombinedSearch = CombinedSearch;
        CombinedSearch.prototype.SearchOptions = [
            { Label: $dyn.label("NavBar_Pages"), Value: 1 },
            { Label: $dyn.label("NavBar_Actions"), Value: 2 }
        ];
        $dyn.ui.addObservablePropertiesToPrototype(CombinedSearch.prototype, {
            CombinedSearchEnabled: $dyn.debug.combinedSearch,
            HasFocus: false,
            SelectedSearchType: 1,
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CombinedSearch.js.map
